import { Flex, RemoteImage, Typography } from '@banhala/ui-kit';

const DEFAULT_ITEM_WIDTH = 64;
const DEFAULT_ICON_SIZE = 52;

export interface IconShortcutProps {
  imageUri: string;
  name: string;
  onPress: () => void;
  /** 라벨 포함 아이템 전체 너비 */
  width?: number;
  /** 아이콘 이미지 크기 */
  iconSize?: number;
}

/**
 * 이미지 아이콘 + 라벨로 구성된 숏컷 아이템.
 * 딥링크/로깅 등 동작은 호출부에서 onPress로 주입한다.
 */
export const IconShortcut = ({
  imageUri,
  name,
  onPress,
  width = DEFAULT_ITEM_WIDTH,
  iconSize = DEFAULT_ICON_SIZE,
}: IconShortcutProps) => {
  return (
    <Flex width={width} alignItems="center" gap={8} onPress={onPress}>
      <RemoteImage uri={imageUri} width={iconSize} height={iconSize} />
      <Typography
        type="body4"
        color="content_primary"
        numberOfLines={1}
        textAlign="center"
      >
        {name}
      </Typography>
    </Flex>
  );
};
